import { i18n } from 'i18n';
import { setSnackbar } from './ui';

export const handleError = (err, dispatch) => {
  console.log('err', err);
  dispatch(setSnackbar(i18n.common.error()));
  return Promise.reject(err);
};
